import { GetterTree } from 'vuex';
import { IRelaysViewState, IRelay } from './types';
import { RootState } from '../../types';
import Vue from 'vue';

export const getters: GetterTree<IRelaysViewState, RootState> = {
    relaysAsDic(state): (deviceNumber: string) => { [no: number]: IRelay } {
        return (deviceNumber: string): { [no: number]: IRelay } => {
            const result: { [no: number]: IRelay } = {};
            const relays = state.device[deviceNumber];
            if (relays) {
                for (const relay of relays) {
                    Vue.set(result, relay.no, relay);
                }
            }
            return result;
        };
    },
    relays(state): (deviceNumber: string) => IRelay[] {
        return (deviceNumber: string): IRelay[] => {
            const relays = state.device[deviceNumber];
            return relays;
        };
    },
};
